import CXMApiClient from "../../CXMApiClient";

import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {};
}

const state = initialState();

const getters = {};

const actions = {
  pushToSerti: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/push_to_dms/serti/push_serti_f_and_i",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/DMSPush/SertiPush.js